import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { of, throwError } from "rxjs";
import { catchError, finalize, first, tap } from "rxjs/operators";

import { DffRouteParams } from "@dffedb/router";
import { DffError } from "@dffedb/util";
import { LoginService } from "@e-forsyning/common/auth";
import { RedirectService } from "@e-forsyning/common/router";

import { LoginData } from "../login-data.model";
import { LoginHjaelpService } from "../login-hjaelp/login-hjaelp.service";

@Component({
    selector: "login-email",
    templateUrl: "./login-email.component.html"
})
export class LoginEmailComponent {
    @Input()
    public parent: UntypedFormGroup;

    @Output()
    public loginSucceeded = new EventEmitter<any>();

    @ViewChild("emailInput", { static: true }) public emailInput: ElementRef;

    public foersteGangAktiveret = false;
    public glemtKodeordAktiveret = false;
    public arbejder = false;
    public infoBesked = "";
    public fejlBesked = "";
    public visFeltFejl = false;

    constructor(
        private readonly loginService: LoginService,
        private readonly loginHjaelpService: LoginHjaelpService,
        private readonly redirectService: RedirectService,
        private readonly routeParams: DffRouteParams
    ) {}

    public focus(): void {
        this.emailInput.nativeElement.focus();
    }

    public loginClick(): void {
        if (this.foersteGangAktiveret && this.parent.valid) {
            this.firstEmailLoginClick();
        } else if (this.glemtKodeordAktiveret) {
            this.sendGlemtKodeordClick();
        } else if (this.foersteGangAktiveret === false) {
            const loginData: LoginData = {
                brugernavn: this.parent.get("emailGroup.email").value,
                kodeord: this.parent.get("emailGroup.adgangskode").value,
                huskMig: this.parent.get("huskMig").value
            };
            this.forbrugerLogin(loginData);
        } else {
            this.visFeltFejl = true;
        }
    }

    public forbrugerLogin(credentials: LoginData): void {
        this.fejlBesked = "";
        this.arbejder = true;
        this.loginService
            .login(credentials.brugernavn, credentials.kodeord, credentials.huskMig)
            .pipe(
                first(),
                tap((result) => {
                    if (result.success) {
                        this.loginSucceeded.emit();
                    } else {
                        this.fejlBesked = "Ugyldig e-mail eller adgangskode";
                    }
                }),
                catchError((error: DffError) => {
                    this.fejlBesked = error.friendlyMessage || error.message;
                    return throwError(error);
                }),
                finalize(() => {
                    this.arbejder = false;
                })
            )
            .subscribe();
    }

    public firstEmailLoginClick(): void {
        const email = this.parent.get("emailGroup.email").value;
        const adgangskode = this.parent.get("emailGroup.adgangskode").value;
        const forbrugerNr = this.parent.get("forbrugerNrGroup.forbrugerNr").value;
        const kode = this.parent.get("forbrugerNrGroup.kode").value;
        this.arbejder = true;
        this.loginService
            .tilknytEmail(forbrugerNr, kode, email, adgangskode)
            .pipe(
                first(),
                tap(() => {
                    this.fejlBesked = "";
                    this.foersteGangAktiveret = false;
                }),
                catchError((error: any) => {
                    console.log("FEJL VED LOGIN:::", error.error);

                    this.fejlBesked = error.error;
                    return of(null);
                }),
                finalize(() => {
                    this.arbejder = false;
                })
            )
            .subscribe();
    }

    public sendGlemtKodeordClick(): void {
        const email = this.parent.get("emailGroup.email").value;
        this.arbejder = true;
        this.loginService
            .glemtKodeord(email)
            .pipe(
                first(),
                tap(() => {
                    this.foersteGangAktiveret = false;
                    this.fejlBesked = "";
                    this.infoBesked = `E-mail sendt til: ${email}`;
                }),
                catchError((error: any) => {
                    console.log("FEJL :::", error.error);
                    this.fejlBesked = error.error;
                    return of(null);
                }),
                finalize(() => {
                    this.arbejder = false;
                })
            )
            .subscribe();
    }

    public onGlemtKodeordClick(): void {
        this.glemtKodeordAktiveret = !this.glemtKodeordAktiveret;
        this.fejlBesked = "";
        this.foersteGangAktiveret = false;
        this.infoBesked = "";
    }

    public firstTimeClick(): void {
        this.fejlBesked = "";
        this.foersteGangAktiveret = !this.foersteGangAktiveret;
    }

    public loginHjaelpClick(): void {
        this.loginHjaelpService.visLoginHjaelpDialog();
    }

    public redirectEfterLogin(): void {
        const path = this.routeParams.get("path");
        if (path && path !== "404") {
            this.redirectService.redirect(path);
        } else {
            this.redirectService.redirectTilInstallationer();
        }
    }
}
